const sacredPath = [
  {
    letter: 'a',
    gift: 'NATURISTA',
    titleText: 'Apreciando la belleza de la creación de Dios.',
    text: `
        <p><b>PERSONAJE BÍBLICO:</b> “Abraham fue un naturista”</p>
        <br/>
        <p>Génesis 15: 5 <br/>
        "Luego el Señor lo llevó afuera y le dijo: Mira hacia el cielo y cuenta las estrellas, a ver si puedes. ¡Así de númerosa será tu descendencia!”</p>
        <p>ESCRITURA PARA MEDITAR:<br/>
         </p>
         <p> Salmo 19: 1 <br/>
         “Los cielos cuentan la gloria de Dios, el firmamento proclama la obra de sus manos”. </p>
        <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
        <p>Busca un lugar al aire libre al que puedas ir regularmente para encontrarte solo con Dios.</p>        
    `,
  },
  {
    letter: 'b',
    gift: 'ENTUSIASTA',
    titleText: 'Se conecta con Dios a través de la celebración.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> “David era un entusiasta”</p>
    <br/>
    <p>1 Crónicas 13: 8 <br/>
        Y David y todo Israel celebraban ante Dios con todas sus fuerzas, con canciones y liras, arpas, panderetas, tambores y trompetas.</p>
    <p>ESCRITURA PARA MEDITAR:<br/>
    (2 Samuel 6:22) NVI
     </p>
     <p> 2 Samuel 6:22<br/>
     “y me rebajaré más todavía, hasta humillarme completamente. Sin embargo, esas mismas esclavas de quienes hablas me rendirán honores”. 
     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Para conectarse con Dios en su tiempo diario con el Señor, imagine que está en la iglesia entrando en su parte favorita del servicio de adoración.
    </p>        
`,
  },
  {
    letter: 'c',
    gift: 'INTELECTUALISTA',
    titleText: 'Obteniendo ideas sobre Dios y la vida con él.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "Salomón fue un intelectualista"</p>
    <br/>
    <p>1 Reyes 3: 5-13 <br/>
    En Gabaón, el Señor se le apareció a Salomón en un sueño por la noche, y Dios dijo: "Pregunta qué te daré". Y Salomón dijo: “Has mostrado un gran y firme amor a tu siervo David mi padre, porque él anduvo delante de ti en fidelidad, en rectitud y en rectitud de corazón hacia ti. Y le has guardado este gran y firme amor y le has dado un hijo para que se siente en su trono este día. Y ahora, Señor, Dios mío, has hecho rey a tu siervo en lugar de David mi padre, aunque yo no soy más que un niño pequeño. No sé cómo salir o entrar. Y tu siervo está en medio de tu pueblo a quien has elegido, un gran pueblo, demasiados para ser contados o contados por multitud. Dale a tu siervo una mente comprensiva para gobernar a tu pueblo, para que yo pueda discernir entre el bien y el mal, porque ¿quién puede gobernar a este tu gran pueblo? Le agradó al Señor que Salomón hubiera preguntado esto. Y Dios le dijo: "Porque has pedido esto, y no te has pedido larga vida o riquezas o la vida de tus enemigos, sino que te has pedido comprensión para discernir lo que es correcto, he aquí, ahora lo hago de acuerdo a tu palabra. He aquí, te doy una mente sabia y perspicaz, para que nadie como tú haya estado antes que tú y nadie como tú se levante después de ti. También te doy lo que no has pedido, tanto riquezas como honor, para que ningún otro rey se compare contigo todos tus días.
    1 Reyes 3: 5-13
    

        </p>
    <p>ESCRITURA PARA MEDITAR:<br/>
    (Proverbios 4: 7)
     </p>
     <p> Proverbios 4: 7
     <br/>
     "El primer paso para ser sabio es tomar la decisión de adquirir sabiduría. Así que usa todo lo que tengas para obtener sabiduría y la conseguirás". 

     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Lee la Biblia pero tratando de entender quién es Dios y la forma en que se relaciona con su pueblo. Esto te ayudará a conectarte con el corazón de Dios, así como a obtener conocimiento acerca de Él.
    </p>        
`,
  },
  {
    letter: 'd',
    gift: 'TRADICIONALISTA',
    titleText: 'Siguiendo tradiciones y prácticas espirituales de larga tradición.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> “La Nación de Israel”</p>
    <br/>
    <p>Génesis 12: 1-3<br/>
    Ahora el Señor le dijo a Abram: “Vete de tu país y de tu parentela y de la casa de tu padre a la
    tierra que te mostraré. Y haré de ti una gran nación, y te bendeciré y haré que tu nombre sea
    grandioso, para que seas una bendición. Bendeciré a los que te bendigan, y al que te
    deshonre, maldeciré, y en ti serán bendecidas todas las familias de la tierra ”

</p>
    <p>ESCRITURA PARA MEDITAR:<br/>
    (Hebreos 13: 7-8)
     </p>
     <p> (Hebreos 13: 7-8)
     <br/>
     “Piensen en los líderes que les anunciaron el mensaje de Dios, pues ellos confiaron siempre en Dios. Piensen mucho en ellos y sigan su ejemplo. Jesucristo nunca cambia: es el mismo ayer, hoy y siempre”. 
     Hebreos 13: 7-8
     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>• Memoriza las Escrituras
    </p>        
`,
  },
  {
    letter: 'e',
    gift: 'MINIMALISTA',
    titleText: 'Abstenerse de las comodidades para hacer más espacio para Dios.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "Los nazareos eran minimalistas"</p>
    <br/>
    <p>Números 6: 1-2 <br/>
    “ Entonces el Señor le dijo a Moisés: «Da al pueblo de Israel las siguientes instrucciones: si alguien del pueblo, sea hombre o mujer, hace el voto especial de nazareo, consagrándose al Señor de manera especial”
    Joel 1:14</p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Pasa tiempo con Dios temprano en la mañana o tarde en la noche: escoge el momento donde te sientas más tranquilo.

    
    </p>        
`,
  },
  {
    letter: 'f',
    gift: 'EXPERIENCIALISTA',
    titleText: 'Experimentar a Dios con sus sentidos físicos o imaginación.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "Ezequiel fue un experiencialista"</p>
    <br/>
    <p>Ezequiel 37: 1-9
    <br/>
    La mano del Señor estaba sobre mí, y él me sacó en el Espíritu del Señor y me puso en el medio del valle Estaba lleno de huesos. Y él me guió entre ellos, y he aquí, había muchos en la superficie del valle, y he aquí, estaban muy secos. Y él me dijo: "Hijo de hombre, ¿pueden vivir estos huesos?" Y le respondí: "Oh Señor Dios, ya sabes". Luego me dijo: “Profetiza sobre estos huesos, y diles: Oh huesos secos, escucha la palabra del Señor. Así dice el Señor Dios a estos huesos: He aquí, haré que entre aire en ti y vivirás. Y pondré nervios sobre ti, y haré que la carne venga sobre ti, y te cubra de piel, y te dé aliento, y vivirás, y sabrás que yo soy el Señor. Así que profeticé como se me ordenó. Y mientras profetizaba, hubo un sonido, y he aquí, un traqueteo, y los huesos se unieron, hueso a hueso. Y miré, y he aquí, había tendones sobre ellos, y carne había venido sobre ellos, y la piel los había cubierto. Pero no había aliento en ellos. Luego me dijo: «Profetiza en el aliento; profetiza, hijo de hombre, y di al aliento: Así dice el Señor Dios: Ven de los cuatro vientos, oh aliento, y respira sobre estos muertos, para que puedan vivir ".
    Ezequiel 37: 1-9
</p>
    <p>ESCRITURA PARA MEDITAR:<br/>
    (Hechos 17:28)
     </p>
     <p> Hechos 17:28
     <br/>
     “Él nos da poder para vivir y movernos, y para ser lo que somos. Así lo dice uno de los poetas de este país: “Realmente somos hijos de Dios.” 
     
     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Crea un espacio de adoración para ti que involucre tus sentidos: enciende una vela, pinta un cuadro,
    decora, expone artículos significativos, una cruz.
    • ¡Ve a Israel!
    
    
    </p>        
`,
  },
  {
    letter: 'g',
    gift: 'COMPASIONISTA',
    titleText: 'Ofrecer la compasión de Dios a aquellos que sufren o luchan.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "El buen samaritano era compasionista"</p>
    <br/>
    
    <p>Lucas 10 <br/>
    <b>Mateo 25: 35-40</b>
    Jesús respondió con una historia:
    —Un hombre judío bajaba de Jerusalén a Jericó y fue atacado por ladrones. Le quitaron la ropa, le pegaron y lo dejaron medio muerto al costado del camino.
    31 »Un sacerdote pasó por allí de casualidad, pero cuando vio al hombre en el suelo, cruzó al otro lado del camino y siguió de largo. 32 Un ayudante del templo[d] pasó y lo vio allí tirado, pero también siguió de largo por el otro lado.
    33 »Entonces pasó un samaritano despreciado y, cuando vio al hombre, sintió compasión por él. 34 Se le acercó y le alivió las heridas con vino y aceite de oliva, y se las vendó. Luego subió al hombre en su propio burro y lo llevó hasta un alojamiento, donde cuidó de él. 35 Al día siguiente, le dio dos monedas de plata[e] al encargado de la posada y le dijo: “Cuida de este hombre. Si los gastos superan esta cantidad, te pagaré la diferencia la próxima vez que pase por aquí”.
    36 »Ahora bien, ¿cuál de los tres te parece que fue el prójimo del hombre atacado por los bandidos? —preguntó Jesús.
    37 El hombre contestó:
    —El que mostró compasión.
    Entonces Jesús le dijo:
    —Así es, ahora ve y haz lo mismo.
    Lucas 10: 30- 37
    
    </p>
    <p>ESCRITURA PARA MEDITAR:<br/>
    “Porque tenía hambre y me diste comida, Tenía sed y me diste de beber, era un extraño y me acogiste, estaba desnudo y me vestiste, estaba enfermo y me visitaste, estaba en prisión y viniste a mí ''. Entonces los justos le responderán, diciendo: 'Señor, ¿cuándo te vimos hambriento y alimentado, o sediento y te dimos de beber? ¿Y cuándo te vimos extraño y te recibimos, o desnudo y te vestimos? ¿Y cuándo te vimos enfermo o en la cárcel y te visitamos? Y el Rey les responderá: "En verdad, te digo que, como lo hiciste con uno de estos mis hermanos más pequeños, me lo hiciste a mí".
    Mateo 25: 35-40
    
    </p>

    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Considera servir en el ministerio en algunos de los proyectos que integran Comunidad Ciudad.

    </p>        
`,
  },
  {
    letter: 'h',
    gift: 'ACTIVISTA',
    titleText: 'Comprometerse activamente con otros para servir a los pobres y necesitados.',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "Esther fue una activista"</p>
    <br/>
    <p>Esther 4:16 <br/>
    “Ve, reúne a todos los judíos que se encuentran en Susa, y ayuna en mi nombre, y no comas ni
    bebas durante tres días, noche o día. Mis jóvenes y yo también ayunaremos como tú. Entonces
    iré al rey, aunque sea contra la ley, y si perezco, pereceré ”.
    
</p>
    (Miqueas 6: 8) NVI
     </p>
     <p> Miqueas 6: 8
     <br/>
     Él te ha mostrado, oh mortal, lo que es bueno. ¿Y qué requiere el Señor de ti? Actuar con justicia y amar la misericordia y caminar humildemente con tu Dios.
     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Busca en tu corazón y encuentra la carga que Dios ya ha puesto dentro de ti y luego pregúntale a Dios qué te ha llamado a hacer al respecto.</p>        
`,
  },
  {
    letter: 'i',
    gift: 'INTIMISTA ',
    titleText: 'Conectando con Dios a través de la intimidad',
    text: `
    <p><b>PERSONAJE BÍBLICO:</b> "María de Betania era una intimista"</p>
    <br/>
    <p>Lucas 7: 44-48 <br/>
    “Luego se volvió hacia la mujer y le dijo a Simón: “¿Ves a esta mujer? Entré en tu casa; no me diste agua para mis pies, pero ella me ha mojado los pies con las lágrimas y las ha limpiado con el pelo. No me besaste, pero desde el momento en que entré no ha dejado de besarme los pies. No me ungiste la cabeza con aceite, pero ella me ha ungido los pies con ungüento. Por eso te digo que sus pecados, que son muchos, son perdonados, porque ella amaba mucho. Pero el que se perdona poco, ama poco ”. Y él le dijo: "Tus pecados te son perdonados".
</p>
    <p>ESCRITURA PARA MEDITAR:<br/>
     </p>
     <p> Salmo 103: 17
     <br/>
     “Pero el amor del Señor permanece para siempre con los que le temen. ¡Su salvación se extiende a los hijos de los hijos” 
     </p>
    <p><b>ACTIVIDADES PRÁCTICAS:</b><br/></p>
    <p>Aparta un momento para pasar tiempo a solas con Jesús en un lugar tranquilo, para que puedas oírlo hablar.
    </p>        
`,
  },
];

const sacredPathQuestions = [
  {
    letter: 'a',
    num: 1,
    sec: 'Me siento más cercano a Dios cuando:',
    question: 'Estoy rodeado de la belleza de la naturaleza.',
  },
  { letter: 'b', num: 2, question: 'Canto canciones de alabanza a Dios.' },
  { letter: 'c', num: 3, question: 'Aprendo algo nuevo sobre Dios o la vida con él.' },
  {
    letter: 'd',
    num: 4,
    question: 'Práctico tradiciones espirituales de mi familia o de Comunidad.',
  },
  { letter: 'e', num: 5, question: 'Me niego a los placeres de la vida y oro.' },
  { letter: 'f', num: 6, question: 'Puedo ver, escuchar o tocar a Dios de alguna manera.' },
  { letter: 'g', num: 7, question: 'Cuido a alguien que está sufriendo.' },
  {
    letter: 'h',
    num: 8,
    question: 'Me uno a otros para defender la causa de los pobres y necesitados.',
  },
  {
    letter: 'i',
    num: 9,
    question: 'Estoy tranquilo y solo, enfocado solo en la presencia de Dios. ',
  },
  {
    letter: 'a',
    num: 10,
    sec: 'Para ser espiritualmente renovado necesito:',
    question: 'Pasar tiempo por fuera disfrutando de la creación de Dios. ',
  },
  {
    letter: 'b',
    num: 11,
    question: 'Celebrar a Dios y su amor con música y canciones de adoración.',
  },
  {
    letter: 'c',
    num: 12,
    question: ' Leer la Biblia y pensar profundamente en lo que Dios está diciendo.',
  },
  {
    letter: 'd',
    num: 13,
    question: 'Reconectar con la historia o los símbolos de mi tradición espiritual. ',
  },
  {
    letter: 'e',
    num: 14,
    question: 'Ayunar comida, redes o simplificar mi vida de alguna otra manera. ',
  },
  {
    letter: 'f',
    num: 15,
    question:
      'Experimentar a Dios de una manera tangible (Ej: recibir la cena del Señor, arrodillarse en el altar, encender una vela u otro).',
  },
  {
    letter: 'g',
    num: 16,
    question:
      'Sentir cómo su compasión fluye a través de mí hacia otra persona (Ej: cuando escuchas, animas u oras por otra persona).',
  },
  {
    letter: 'h',
    num: 17,
    question:
      'Ser parte de una causa para promover el cuidado de aquellos que son menos afortunados que yo.',
  },
  { letter: 'i', num: 18, question: 'Contemplar en silencio el amor de Dios.' },
  {
    letter: 'a',
    num: 19,
    sec: 'Es especialmente útil para mí conectarme con Dios a través de:',
    question: 'Apreciar las maravillas que Dios ha creado.',
  },
  {
    letter: 'b',
    num: 20,
    question: 'Expresar de manera eufórica agradecimiento y alabanza a Dios. ',
  },
  { letter: 'c', num: 21, question: 'Estudiar la Biblia cuidadosamente.' },
  {
    letter: 'd',
    num: 22,
    question: 'Usar un plan de lectura o devocional u oraciones proporcionadas por mi Comunidad.',
  },
  { letter: 'e', num: 23, question: 'Manteniendo mi vida simple y ordenada.' },
  {
    letter: 'f',
    num: 24,
    question:
      'Imaginarme en una historia del evangelio, una obra de arte religioso o una película espiritual. ',
  },
  { letter: 'g', num: 25, question: 'Apoyar a un amigo que está pasando por un momento difícil.' },
  {
    letter: 'h',
    num: 26,
    question:
      'Ayudar a un vecino enfermo, proporcionar comida a los hambrientos o ministrar a los ancianos, abusados ​​o encarcelados.',
  },
  {
    letter: 'i',
    num: 27,
    question:
      ' Meditar en las Escrituras o en un libro devocional que me lleva a una intimidad más profunda con Dios.',
  },
  {
    letter: 'a',
    num: 28,
    sec: 'Me beneficio especialmente de oradores y autores que me ayudan a',
    question: 'Apreciar la belleza de Dios y las maravillas de su creación.',
  },
  { letter: 'b', num: 29, question: 'Agradecer y alabar a Dios con alegría' },
  { letter: 'c', num: 30, question: 'Comprender nuevas cosas sobre mi vida con Dios.' },
  { letter: 'd', num: 31, question: 'Recordar las historias y acciones de héroes de la biblia.' },
  {
    letter: 'e',
    num: 32,
    question: 'Ser disciplinado para hacer más espacio en mi vida y mi alma para Dios.',
  },
  { letter: 'f', num: 33, question: `Experimentar el "toque" de la presencia de Dios en mí.` },
  {
    letter: 'g',
    num: 34,
    question: 'Ser más efectivo a la hora de cuidar a las personas con dificultades. ',
  },
  { letter: 'h', num: 35, question: 'Defiende la justicia e impacta a los marginados' },
  {
    letter: 'i',
    num: 36,
    question: 'Amar a Dios todo el tiempo en el lugar secreto de mi corazón. ',
  },
];

export { sacredPath, sacredPathQuestions };
